import React from 'react'
import { getPresentationContentStyles, Grid, Link, Typography, makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme, StyleClasses } from '@paintscout/ui'
import type { LabelsOption } from '@paintscout/util/builder'
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined'

const useStyles = makeStyles<Theme, AboutEstimatorPlaceholderProps>(
  (theme) => ({
    root: {
      '&$root': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 125,
        backgroundColor: theme.palette.grey[100],
        ...getPresentationContentStyles(theme, { noMargins: ['li'] })
      }
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      alignContent: 'center',
      textAlign: 'center'
    }
  }),
  { name: 'AboutEstimatorPlaceholder' }
)

export interface AboutEstimatorPlaceholderProps {
  classes?: StyleClasses<typeof useStyles>
  objectLabels: LabelsOption
  /** Only in the editor canvas: it has the app router, unlike customer view or the preview iframe */
  showProfileLink?: boolean
}

function AboutEstimatorPlaceholder(props: AboutEstimatorPlaceholderProps) {
  const classes = useStyles(props)
  const { objectLabels, showProfileLink } = props

  return (
    <div className={classes.root}>
      <Grid className={classes.container} container spacing={1}>
        <Grid item xs={8}>
          <PersonOutlineOutlinedIcon />
        </Grid>
        <Grid item xs={8}>
          <Typography variant={'h2'}>About Your Estimator</Typography>
        </Grid>
        <Grid className={classes.container} item xs={8}>
          <Typography variant={'subtitle1'}>Estimator details are inserted automatically.</Typography>
          <Typography variant={'subtitle1'}>
            {`When viewing or sending, the photo, name and description of the estimator assigned to the ${objectLabels.quote.value.toLowerCase()} appear here.`}
          </Typography>
          {showProfileLink && (
            <Typography variant={'subtitle1'}>
              Set your own photo and description in your <Link to="/profile?category=profile">profile</Link>.
            </Typography>
          )}
        </Grid>
        <Grid className={classes.container} item xs={6}></Grid>
      </Grid>
    </div>
  )
}

export default AboutEstimatorPlaceholder
